import { hasMovingAnswer, type NextoriesData } from '../scripts/nextoriesFields'
import { defineSaleProgress, hasAddress, isSaleCreated, isSaleStarted, type ProgressSaleData } from '../saleProgress'

interface MovingNextoriesData extends ProgressSaleData, NextoriesData {}

const PULSE = 'additionalSales:pulse.'

export default defineSaleProgress<MovingNextoriesData>({
  kind: 'sale',
  steps: [
    { key: 'address', label: `${PULSE}timeline.address`, done: hasAddress },
    { key: 'created', label: `${PULSE}timeline.created`, done: isSaleCreated },
  ],
  status: (data, steps) => {
    if (steps[steps.length - 1].state === 'done') return 'signed'
    const isInProgress = isSaleStarted(data) || hasAddress(data) || hasMovingAnswer(data)
    if (isInProgress) return 'progress'

    return 'new'
  },
  doneLabel: `${PULSE}progress.sale_created`,
})
